import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { Mutation, Getter } from 'vuex-class';
import { NAV_DRAWER } from '@/helpers/constants/app';
const opts = { namespace: NAV_DRAWER };
let DiyPreviewDrawerMixin = class DiyPreviewDrawerMixin extends Mixins(ViewportSizeMixin) {
    onToggle(val) {
        if (!val) {
            this.hideMiniAppPreview();
        }
    }
    get drawerWidth() {
        if (this.xsOnly) {
            return '637';
        }
        return '500';
    }
    get drawerHeight() {
        if (this.xsOnly) {
            return 'calc(100% - 65px)';
        }
        return 'calc(100% - 72px)';
    }
};
__decorate([
    Getter('showMiniAppPreview', opts)
], DiyPreviewDrawerMixin.prototype, "miniAppPreview", void 0);
__decorate([
    Mutation('hideMiniAppPreview', opts)
], DiyPreviewDrawerMixin.prototype, "hideMiniAppPreview", void 0);
__decorate([
    Mutation('showMiniAppPreview', opts)
], DiyPreviewDrawerMixin.prototype, "showMiniAppPreview", void 0);
DiyPreviewDrawerMixin = __decorate([
    Component
], DiyPreviewDrawerMixin);
export default DiyPreviewDrawerMixin;
